import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { AdminLogsComponent } from './pages/admin-logs/admin-logs.component';
import { VisitorAnalyticsComponent } from './pages/visitor-analytics/visitor-analytics.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboards/project'
    { path: '', pathMatch: 'full', redirectTo: 'sign-in' },

    // Redirect signed-in user to the '/dashboard'

    // Auth routes for users
    {
        path: '',
        // canMatch: [NoAuthGuard],
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {
                path: 'confirmation-required',
                loadChildren: () =>
                    import('app/modules/auth/confirmation-required/confirmation-required.module')
                        .then(m => m.AuthConfirmationRequiredModule)
            },
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import('app/modules/auth/forgot-password/forgot-password.module')
                        .then(m => m.AuthForgotPasswordModule)
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import('app/modules/auth/reset-password/reset-password.module')
                        .then(m => m.AuthResetPasswordModule)
            },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.module')
                        .then(m => m.AuthSignInModule)
            },
            {
                path: 'sign-up',
                loadChildren: () =>
                    import('app/modules/auth/sign-up/sign-up.module')
                        .then(m => m.AuthSignUpModule)
            }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        // canMatch: [AuthGuard],
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.module')
                        .then(m => m.AuthSignOutModule)
            }
        ]
    },

    // Admin routes
    {
        path: '',
        // canMatch: [AuthGuard],
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            // Dashboard
            {
                path: 'dashboard',
                pathMatch: 'full',
                loadChildren: () =>
                    import('app/modules/admin/dashboard/dashboard.module')
                        .then(m => m.DashboardModule)
            },
            {
                path: 'master',
                loadChildren: () =>
                    import('app/modules/admin/master/master.module')
                        .then(m => m.MasterModule)
            },
            {
                path: 'blog',
                loadChildren: () =>
                    import(
                        'app/modules/admin/blog-layout/blog.module'
                    ).then(m => m.BlogListModule),
            },
            {
                path: 'profile',
                loadChildren: () =>
                    import('app/modules/admin/pages/profile/profile.module').then(
                        m => m.ProfileModule
                    ),
            },
            {
                path: 'logs-api',
                component: AdminLogsComponent,
            },
            {
              path: 'visitor',
              component: VisitorAnalyticsComponent,
            },
            // 404 & Catch all
            {
                path: '404-not-found',
                pathMatch: 'full', loadChildren: () =>
                    import('app/modules/admin/pages/error/error-404/error-404.module')
                        .then(m => m.Error404Module)
            },
            {
                path: '**',
                redirectTo: '404-not-found'
            }
        ]
    }
];
